import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTaskRowComment, rowCommentModified, saveTaskRowComment } from "../../redux/ducks/task";
import useStatusThunk from "../../hook/useStatusThunk";
import LoadingButton from "../dumb/LoadingButton";

const TaskRowComment = props => {

    const dispatch = useDispatch();
    const [dispatch_save, status_save, error_save, e_save] = useStatusThunk(saveTaskRowComment);
    const [dispatch_fetch, status_fetch, error_fetch, e_fetch] = useStatusThunk(fetchTaskRowComment);

    const selectedTaskRowID = useSelector(state => state.task.tasks[props.taskID]?.selectedRow);
    const rows = useSelector(state => state.task.tasks[props.taskID]?.rows);
    const row = rows ? rows[selectedTaskRowID] : null;
    const text = row?.comment?.text ? row?.comment?.text : "";

    /* Fetch comment for selected row */
    useEffect(() => {
        dispatch_fetch({rowID:selectedTaskRowID, taskID: props.taskID});
    }, [selectedTaskRowID]);

    if(status_fetch == "pending") return <div className="textarea--task-row-comment-container">Loading</div>

    return <div className="textarea--task-row-comment-container">
        <textarea onChange={e => {
            dispatch(rowCommentModified({ taskID: props.taskID, rowID: selectedTaskRowID, comment: e.target.value }));
        }} className={"input textarea--task-row-comment " + (row?.comment?.modified ? "textarea--task-row-comment--modified" : "")} value={text} placeholder="Add a comment...">
        </textarea>
        
        <LoadingButton loading={status_save=="pending"} className="button--save-task-row-comment" onClick={e => {
            dispatch_save({ rowID: selectedTaskRowID, comment: text, taskID: props.taskID});
        }}>Save</LoadingButton>
    </div>
}

export default TaskRowComment;